import { render } from "./info.vue?vue&type=template&id=6fbb6ed8&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=6fbb6ed8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6fbb6ed8"

export default script